/* eslint-disable jsx-a11y/label-has-associated-control , react/no-unescaped-entities */
import React,{ forwardRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { useFormContext,Controller } from 'react-hook-form';
import UserMultiSelect from '../challengeFlow/components/UserMultiSelect';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    wrp:{
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title:{
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1.25rem',
        margin: '0 0 2rem 0', 
        textAlign: 'left',
        color:"#333",
        
      },
    fieldsetBox:{
        marginBottom:theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label':{
            fontFamily: 'VodafoneRg-bold', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            display:'block',
        },
        '& input[type="text"],input[type="date"],select':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '2.5rem',
            border: '1px solid #333',
            // padding: '0.5rem',
            boxSizing: 'border-box',
        },
        '& input[type=date]:before':{content:'none'},
        '& textarea':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize:'none'
        },
        
        
    },
    basicSearchchallengeOwner:{
        fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '3rem',
            // border: '1px solid #333',
            // padding: '0.5rem',
            boxSizing: 'border-box',
    },
    error:{
        color:"red",
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
    },
    labelname:{
        fontFamily: 'VodafoneRg-bold', 
        margin: '0 0 0.5rem 0', 
        fontSize: '1.125rem',
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    
    wrp2cols:{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem'
    },
  }));
  

export const ChallengeOwner = (props) => {

const {
    listCommunitesChallenge:listCommunites=[],
    challengeOrganizerEmailList,
    getSearchUserFn,
    searchUserSuggestion,
    searchUserSuggestionsIsLoading,
    onUserChange,
    mergeUniqueUsers,
    userEmail,
    isAdmin,
} = props || {}

const classes = useStyles();

const { register, control,setValue,getValues,formState: { errors } } = useFormContext();

const [optionList, setOptionList] = React.useState([]);

const [challengeOwnerMustApprove, setChallengeOwnerMustApprove] = React.useState(true);


useEffect(() => {
    if (challengeOrganizerEmailList?.length) {
      const formattedUsers = challengeOrganizerEmailList.map(email => ({
        label: email,
        value: email
      }))
  
      setValue('search', formattedUsers) 
    }
  }, [challengeOrganizerEmailList])
  

const handleChange = (event) => {
    setChallengeOwnerMustApprove(event.target.checked);
};

useEffect(()=>{
    const challengeOwnerOption = listCommunites.map(group => 
        ({
            value: group.id,
            label: group.name
        })
    );
    const filterChallengeOwnerOption =  challengeOwnerOption.sort((a, b) => a?.label?.localeCompare(b?.label))
    setOptionList(filterChallengeOwnerOption)
},[])




  return (
    <div className={classes.wrp}>

        {/* <h2 className={classes.title}>Owner & Communities</h2> */}
        {/* <h3 className={classes.labelname}>Approval Settings</h3> */}
        {/* <fieldset className={classes.fieldsetBox}>
            <label htmlFor='mustApprove'>Challenge owner must approve all ideas after evaluation workflow</label>
            <Switch
                checked={challengeOwnerMustApprove}
                onChange={handleChange}
                name="mustApprove"
                id="mustApprove"
                inputProps={{ 'aria-label': ' checkbox' }}
            />
        </fieldset> */}


        <h3 className={classes.labelname}>Communities</h3>
        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='communities' title='`*Only people in these communities can submit ideas, like, rate and comment.`' > Select Communities who can submit ideas*</label>
            <Controller
                name="communities"
                control={control}
               
                render={({ field }) => (
                    <Select
                    {...field}
                    options={optionList}
                    isMulti
                    placeholder="Select..."
                    id="communities"
                    styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: '#333',
                        }),
                      }}
                  />
                    
                )}
            />
            {errors?.communities?.message && <p className={classes.error}>{errors?.communities?.message}</p>}
        </fieldset>
        {/* <fieldset className={classes.fieldsetBox}>
            <label htmlFor='cannotSubmitIdeas' title='`*People in these communities can like, rate comment but cannot submit ideas.`'> Select Communities who can participate socially but cannot submit ideas</label>
            <MultiSelectCheckbox optionData={challengeOwnerOption} idname='cannotSubmitIdeas' />
        </fieldset>
        <h3 className={classes.labelname}>Challenge Editors</h3>
        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='challengeEditors' > Select others who can edit this challenge</label>
            <span><i>*Please note, they must have 'Admin' or 'Create Challenge' permissions.</i></span>
            <MultiSelectCheckbox optionData={challengeOwnerOption} idname='challengeEditors' />
        </fieldset> */}


        {/* <fieldset className={classes.fieldsetBox}>
        <label htmlFor="search">Challenge Manager </label>
        <Controller
            name="search"
            control={control}
            defaultValue={[]}
            render={({ field }) => {

                const handleSearchUserOnChange = (users) => {
                field.onChange(users || [])
                onUserChange?.(users || []) 
                }

                return (
                <UserMultiSelect
                    value={field.value || []}    
                    onChange={handleSearchUserOnChange}
                    fetchUserSuggestions={getSearchUserFn}
                    searchUserSuggestions={searchUserSuggestion}
                    isLoading={searchUserSuggestionsIsLoading}
                    userEmail={userEmail}
                    isAdmin={isAdmin}
                />
                )
            }}
            />

        </fieldset> */}

        <fieldset className={classes.fieldsetBox}>
        <label htmlFor="search">Challenge Co-Organizer </label>
        <p><b>Note:</b> Please ensure the co-organizer is part of the community  </p>
        <Controller
            name="search"
            control={control}
            defaultValue={[]}
            render={({ field }) => {

              
const handleSearchUserOnChange = (users) => {
    let updatedUsers = users || []
  
    //  only block adding current user
    if (isAdmin && userEmail) {
      updatedUsers = updatedUsers.filter(
        user => user.value !== userEmail
      )
    }
  
    field.onChange(updatedUsers) 
    onUserChange?.(updatedUsers)
  }

                return (
                <UserMultiSelect
                    value={field.value || []}    
                    onChange={handleSearchUserOnChange}
                    fetchUserSuggestions={getSearchUserFn}
                    searchUserSuggestions={searchUserSuggestion}
                    isLoading={searchUserSuggestionsIsLoading}
                    userEmail={userEmail}
                    isAdmin={isAdmin}
                />
                )
            }}
            />

        </fieldset>
        
    </div>
  )
}


const MultiSelectCheckbox = forwardRef(
    (props,ref) => {
        const { optionData,idname,onChange } = props || {}
    
        const filterColors = (inputValue) => {
            return optionData.filter((i) =>
                i.label.toLowerCase().includes(inputValue.toLowerCase())
            );
        };
    
        const promiseOptions = (inputValue) =>
            new Promise((resolve) => {
                setTimeout(() => {
                    resolve(filterColors(inputValue));
                }, 1000);
            });
    
        return (
            <AsyncSelect
                placeholder=' Select...'
                isMulti
                defaultOptions
                loadOptions={promiseOptions}
                id={idname}
                onChange={onChange}
                ref={ref}
            />
        )
    } 
)


MultiSelectCheckbox.displayName = 'MultiSelectCheckbox';


